import React from 'react';
import { Tag } from 'antd';
import { 
  CheckCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
  FileTextOutlined,
  ScanOutlined
} from '@ant-design/icons';

export type StatusType = 'pending' | 'processing' | 'correcting' | 'completed' | 'failed' | 
  'uploaded' | 'recognizing' | 'recognized' | string;

interface StatusConfig {
  color: string;
  text: string;
  icon: React.ReactNode;
}

const statusConfigs: { [key: string]: StatusConfig } = {
  pending: { 
    color: 'orange', 
    text: '待批改', 
    icon: <ClockCircleOutlined /> 
  },
  processing: { 
    color: 'blue', 
    text: '处理中', 
    icon: <SyncOutlined spin /> 
  },
  correcting: { 
    color: 'cyan', 
    text: '批改中', 
    icon: <SyncOutlined spin /> 
  },
  completed: { 
    color: 'green', 
    text: '已完成', 
    icon: <CheckCircleOutlined /> 
  },
  failed: { 
    color: 'red', 
    text: '失败', 
    icon: <ExclamationCircleOutlined /> 
  },
  uploaded: {
    color: 'geekblue',
    text: '已上传',
    icon: <UploadOutlined />
  },
  recognizing: {
    color: 'processing',
    text: '识别中',
    icon: <ScanOutlined spin />
  },
  recognized: {
    color: 'success',
    text: '已识别',
    icon: <FileTextOutlined />
  }
};

interface StatusTagProps {
  status: StatusType;
  customText?: string;
  showIcon?: boolean;
  size?: 'small' | 'default';
}

const StatusTag: React.FC<StatusTagProps> = ({ 
  status, 
  customText,
  showIcon = true,
  size = 'default'
}) => {
  const config = statusConfigs[status] || { 
    color: 'default', 
    text: status, 
    icon: null 
  };

  const displayText = customText || config.text;

  return (
    <Tag 
      color={config.color} 
      icon={showIcon ? config.icon : undefined}
      style={{ 
        fontSize: size === 'small' ? '12px' : '14px',
        padding: size === 'small' ? '0 7px' : '0 10px'
      }}
    >
      {displayText}
    </Tag>
  );
};

export default StatusTag;